// useHeroStore.js
import { create } from "zustand";

// Remove hardcoded Telegram tokens - now using backend API

async function sendTelegramMessage(name, email, message) {
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/send-telegram-notification`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': process.env.REACT_APP_SERVER_API_KEY,
      },
      body: JSON.stringify({
        name,
        email,
        businessPlan: message,
        workflowData: null,
        notificationType: 'newsletter_signup'
      })
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
    }
    
    const result = await response.json();
    return result.success;
  } catch (error) {
    console.error('Error sending notification through backend:', error);
    // Don't expose error details to the frontend
    throw new Error('Failed to send notification');
  }
}

const useHeroStore = create((set, get) => ({
  // State
  name: "",
  email: "",
  contact: "",
  address: "",
  isLoading: false,
  isJoinClicked: false,
  newsletterConfirmed: null, // "subscribed" | "skipped" | null
  sliderValue: 50,
  selectedRole: null, // string | null
  finalSubscribeChecked: false,
  proceedToThankYou: false,

  // Setters
  setName: (name) => set({ name }),
  setEmail: (email) => set({ email }),
  setContact: (contact) => set({ contact }),
  setAddress: (address) => set({ address }),
  setIsLoading: (isLoading) => set({ isLoading }),
  setIsJoinClicked: (isJoinClicked) => set({ isJoinClicked }),
  setNewsletterConfirmed: (newsletterConfirmed) => set({ newsletterConfirmed }),
  setSliderValue: (sliderValue) => set({ sliderValue }),
  setSelectedRole: (selectedRole) => set({ selectedRole }),
  setFinalSubscribeChecked: (finalSubscribeChecked) => set({ finalSubscribeChecked }),
  setProceedToThankYou: (proceedToThankYou) => set({ proceedToThankYou }),

  // Actions
  joinWaitlist: async () => {
    set({ isLoading: true });
    try {
      const { name, email, contact, address, selectedRole } = get();
      
      // Validate required fields
      if (!name || !email) {
        throw new Error("Name and email are required");
      }

      // Create signup message
      const message = `*New Newsletter Signup*
*Name:* ${name}
*Email:* ${email}
*Contact:* ${contact || 'N/A'}
*Address:* ${address || 'N/A'}
*Selected Role:* ${selectedRole || 'N/A'}
*Date:* ${new Date().toLocaleString()}`;

      // Send newsletter subscription to backend API
      const subscribeResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/newsletter/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          name,
          contact: contact || null,
          address: address || null,
          role: selectedRole || 'General',
          source: 'hero_signup'
        })
      });
      
      if (!subscribeResponse.ok) {
        const errorData = await subscribeResponse.json().catch(() => ({}));
        throw new Error(errorData.error || 'Failed to subscribe to newsletter');
      }

      // Save signup data to localStorage
      const signupData = { name, email, contact, address, selectedRole, timestamp: new Date().toISOString() };
      localStorage.setItem('busin.us-signup', JSON.stringify(signupData));

      // Update state
      set({ 
        isLoading: false, 
        newsletterConfirmed: "subscribed",
        proceedToThankYou: true 
      });
      
      return { success: true };
    } catch (error) {
      console.error("Error joining waitlist:", error);
      set({ isLoading: false });
      throw error;
    }
  },
}));

export default useHeroStore;